const initialState = [
];

const reduceClientBoxData = (state = initialState, { type, payload }) => {
  switch (type) {
    case "PUSHDATACLIENTBOX":
      return payload;
    case "REMOVEDATACLIENTBOX":
      return [];
    default:
      return state;
  }
};

export default reduceClientBoxData;
